import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, HStack, Box, Text } from "@chakra-ui/react";
import { BsChevronDown } from "react-icons/bs";
import { CalendarLink, DropdownMenu } from "components";
import { Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import ICalendarLink from "react-icalendar-link";
import { GetAttendeeList } from "utils/user";
import { useQueryClient, QueryClient, Mutation} from "@tanstack/react-query"

import {
  useCancelSession,
  useCompleteSession,
  useUpdateSession
} from "repo/sessions";
import {
  isActiveSession,
  isCancellableSession,
  isCancelledSession,
  isCompletedSession,
  isFutureSession,
  isPastSession
} from "utils/session";
import { useModal } from "context/modal";
import { Session } from "types";
import { useToast } from "hooks";
import SessionForm from "pages/Sessions/SessionForm"

interface Props {
  session: Session;
}

const AppointmentOptionsButton: React.FC<Props> = ({ session }: Props) => {
  const history = useHistory();
  const { openModal, closeModal, setTitle, setContent } = useModal()!;
  const toast = useToast();

  const canCancel = isCancellableSession(session);

  const openEditModal = () => {
    setTitle("Update Session");
    setContent(
      <SessionForm
        mutationFn={useUpdateSession}
        session={session}
        completed={!canCancel}
        isUpdate={true}
      />
    );
    openModal();
  };


  const completeSessionMutation = useCompleteSession();
  const cancelSessionMutation = useCancelSession();

  return (
    <Box>
      <Menu>
        {({ isOpen }) => (
          <>
            <MenuButton
              isActive={isOpen}
              as={Button}
              size="xs"
              bgColor="transparent"
              color="white"
              borderColor="transparent"
              _hover={{ bg: "transparent" }}
              _active={{ bg: "transparent" }}
              _focus={{ bg: "transparent" }}
            >
              <Text fontSize="lg" fontWeight="bold">
                . . .
              </Text>
            </MenuButton>
            <MenuList
              bgColor="gray.700"
              color="gray.100"
            >
              <MenuItem
                onClick={openEditModal}
                _hover={{ bg: "gray.100", color: "gray.700" }}
                _focus={{ bg: "gray.100", color: "gray.700" }}
              >
                Edit
              </MenuItem>
              <ICalendarLink
                event={{
                  title: session.title,
                  startTime: session.start_time.toString(),
                  endTime: session.end_time.toString(),
                  attendees: GetAttendeeList(session.coach, session.participants)
                }}
              >
                <MenuItem
                  _hover={{ bg: "gray.100", color: "gray.700" }}
                  _focus={{ bg: "gray.100", color: "gray.700" }}>
                  Add to calendar
                </MenuItem>
              </ICalendarLink>
              <MenuItem
                hidden={
                  !isPastSession(session) ||
                  isCancelledSession(session) ||
                  isCompletedSession(session)
                }
                onClick={() => completeSessionMutation.mutate(session)}
                _hover={{ bg: "gray.100", color: "gray.700" }}
                _focus={{ bg: "gray.100", color: "gray.700" }}
              >
                Complete
              </MenuItem>
              <MenuItem
                hidden={!canCancel}
                onClick={() => cancelSessionMutation.mutate(session)}
                _hover={{ bg: "gray.100", color: "gray.700" }}
                _focus={{ bg: "gray.100", color: "gray.700" }}
              >
                Cancel
              </MenuItem>
            </MenuList>
          </>
        )}
      </Menu>
    </Box>
  );
}

export default AppointmentOptionsButton;
